// HALCYON brand — central asset registry, content & image URLs
// Premium sustainable apparel · Designed in Lisbon, made in Portugal

window.BRAND = {
  name: 'HALCYON',
  tagline: 'Made slowly, worn always.',
  origin: 'Lisbon · Portugal',
  hero: 'The Almond Coat',
  price: 480
};

function unsplash(id, w = 1200) {
  return `https://images.unsplash.com/photo-${id}?w=${w}&auto=format&fit=crop&q=80`;
}

// Curated, verified-working image set (all Unsplash, no broken links)
window.IMAGES = {
  // Campaign / hero
  campaign_coat:    unsplash('1571513722275-4b41940f54b8'),     // figure in cream/almond — primary hero
  campaign_atelier: unsplash('1582719188393-bb71ca45dbb9'),     // clothing rail — retail atmosphere
  campaign_walk:    unsplash('1483985988355-763728e1935b'),     // figure in coat outdoors
  campaign_flat:    unsplash('1593030761757-71fae45fa0e7'),     // outfit flat lay (suit + shoes)
  campaign_door:    unsplash('1487222477894-8943e31ef7b2'),     // figure in tan coat

  // Product photos — Almond Coat in 5 colors (using best-matched model/colour shots)
  product_coat_almond:   unsplash('1571513722275-4b41940f54b8'), // cream/almond
  product_coat_obsidian: unsplash('1483985988355-763728e1935b'), // dark/burgundy
  product_coat_bone:     unsplash('1581338834647-b0fb40704e21'), // light/white
  product_coat_moss:     unsplash('1503342217505-b0a15ec3261c'), // earthy lifestyle
  product_coat_clay:     unsplash('1487222477894-8943e31ef7b2'), // tan/brown coat

  // Related products (other HALCYON pieces)
  product_linen_shirt:  unsplash('1591047139829-d91aecb6caea'), // brown soft fabric
  product_wool_trouser: unsplash('1604176354204-9268737828e4'), // folded denim stack
  product_leather_tote: unsplash('1492707892479-7bc8d5a4ee93'), // accessories flat lay
  product_cardigan:     unsplash('1556905055-8f358a7a47b2'),    // knit/sweater
  product_scarf:        unsplash('1612722432474-b971cdcea546'), // soft texture
  product_hangers:      unsplash('1551488831-00ddcb6c6bd3'),    // coat hangers

  // Composition / "ingredients" photos — texture-led close-ups
  fabric_wool:   unsplash('1556905055-8f358a7a47b2'),  // knit close-up
  fabric_linen:  unsplash('1591047139829-d91aecb6caea'), // soft fold
  fabric_silk:   unsplash('1571513722275-4b41940f54b8'), // smooth cream surface
  fabric_horn:   unsplash('1593030761757-71fae45fa0e7'), // flat lay shows hardware

  // Reviewer photos (used in grid variant)
  review_photo_1: unsplash('1582719188393-bb71ca45dbb9'),
  review_photo_2: unsplash('1605518216938-7c31b7b14ad0'),
  review_photo_3: unsplash('1564859228273-274232fdb516'),
  review_photo_4: unsplash('1473496169904-658ba7c44d8a'),

  // Atelier / brand story
  atelier_detail: unsplash('1582719188393-bb71ca45dbb9'), // hangers — retail/atelier feel
  atelier_hands:  unsplash('1620799140408-edc6dcb6d633'), // white sweatshirt flat lay
  atelier_room:   unsplash('1490481651871-ab68de25d43d'), // apparel scene

  // Banner backdrop
  banner_archive: unsplash('1496747611176-843222e1e57c')
};

// Realistic content blocks — used across previews

window.HALCYON_CONTENT = {

  hero: {
    eyebrow: 'New · SS26 collection',
    title_pre:  'Made slowly,',
    title_em:   'worn always.',
    body: 'Considered essentials, cut from European wool and Portuguese linen. Designed in Lisbon, made by hand in our atelier in Porto. Built to outlast a decade of wear.',
    cta_primary: 'Shop SS26',
    cta_secondary: 'Read the story'
  },

  banner: {
    promo_text:  'Free express shipping on orders over $200 — through Sunday',
    promo_cta:   'Shop now',
    archive_eyebrow: 'Final cuts · 3 days left',
    archive_title:   'SS25 Archive',
    archive_body:    'Up to 40% off select pieces from past seasons. No restock — once they\'re gone, they\'re gone.',
    archive_cta:     'Shop the archive',
    marquee: [
      'Free express shipping on orders $200+',
      '30-day returns, no questions',
      'Carbon-neutral delivery',
      'Made in Portugal · since 2017'
    ]
  },

  faq: [
    { q: 'How does HALCYON sizing run?',
      a: "Our pieces are cut for an easy, modern fit — true to size for most. The Almond Coat runs slightly oversized in the shoulders; if you're between sizes, take the smaller. Every product page has full measurements, plus a fit-check chat option in the bottom right.",
      topic: 'Sizing' },
    { q: 'When will my order arrive?',
      a: 'In-stock orders ship from our Porto warehouse within 1 business day. Express delivery is 2–4 days within the EU and US, 4–7 days for the rest of the world. Made-to-order pieces ship in 3–4 weeks.',
      topic: 'Shipping' },
    { q: 'What is your return policy?',
      a: 'Free returns within 30 days of delivery on unworn items with tags attached. Returns are refunded to your original payment method within 5 business days of arriving at our warehouse. Made-to-order items are final sale.',
      topic: 'Returns' },
    { q: 'How should I care for my coat?',
      a: "Hang on a wide wooden hanger, away from direct sunlight. Spot-clean small marks with cold water and a soft cloth; for anything more, take it to a trusted dry cleaner who specialises in wool. A linen care card is included with every order.",
      topic: 'Care' },
    { q: 'Are your materials certified?',
      a: 'Every textile we use is certified by GOTS, OEKO-TEX Standard 100, or RWS. Our wool is from a fourth-generation mill in the Yorkshire dales; our linen is grown and spun in northern Portugal. Full traceability is on each product page.',
      topic: 'Materials' },
    { q: 'Can I customise a piece?',
      a: 'For made-to-order garments, we can adjust sleeve and hem length, change the lining colour, and add monogramming. Reach out via chat to start a custom request — most take 4–6 weeks.',
      topic: 'Custom' }
  ],

  reviews: [
    { rating: 5, title: 'Better than I dared hope',  author: 'Saira K.',   location: 'Brooklyn, NY',  date: '3 days ago',
      body: "I've been looking for a coat like this for three winters. The wool is dense without being stiff, and the cut sits beautifully over a jumper. The buttons alone feel like a small luxury. Took it straight on a trip to Edinburgh — warm, elegant, dries quickly. My new most-worn piece.",
      verified: true, size: 'M · Almond' },
    { rating: 5, title: 'Exceptional from packaging in',  author: 'Tomás B.',  location: 'Lisbon, PT',    date: '1 week ago',
      body: 'The detail is remarkable. Arrived in a linen dust bag with a hand-written card from the maker, faster than I expected from a small brand. Everyone who has seen it has asked where it\'s from.',
      verified: true, size: 'L · Obsidian' },
    { rating: 4, title: 'Beautifully made, runs slim',  author: 'Mia L.',     location: 'Amsterdam, NL', date: '2 weeks ago',
      body: 'Stunning piece — the linen is sublime — but the shoulders are slimmer than I expected. Sized up after a quick chat with the team; the exchange was painless. Knocking off a star for the fit info on the site.',
      verified: true, size: 'S → M · Bone' },
    { rating: 5, title: 'Worth the wait',                author: 'Daniel A.', location: 'San Francisco', date: '1 month ago',
      body: 'Made-to-order so it took five weeks, but it was worth every day. The lining is silk, the buttons are corozo nut, the seams are clean inside and out. This is the coat I\'ll be wearing in ten years.',
      verified: false, size: 'L · Moss' },
    { rating: 5, title: 'My second HALCYON piece',       author: 'Olivia M.', location: 'London, UK',    date: '6 weeks ago',
      body: 'Bought the linen shirt last summer, and this coat in autumn. Both pieces have been in heavy rotation. The quality is consistent and the service is genuinely thoughtful.',
      verified: true, size: 'XS · Clay' }
  ],

  specs: [
    { name: 'Outer shell',  value: '68% wool · 32% linen',           group: 'Composition' },
    { name: 'Lining',       value: '100% silk · charmeuse weave',    group: 'Composition' },
    { name: 'Weight',       value: '780 g · midweight',              group: 'Form' },
    { name: 'Length',       value: '105 cm at the back',             group: 'Form' },
    { name: 'Closure',      value: '4 corozo-nut buttons',           group: 'Form' },
    { name: 'Origin',       value: 'Cut & sewn in Porto, Portugal',  group: 'Sourcing' },
    { name: 'Certification','value': 'GOTS · OEKO-TEX · RWS',        group: 'Sourcing' },
    { name: 'Care',         value: 'Dry clean · low-impact only',    group: 'Care' }
  ],

  ingredients: [
    { name: 'British wool',       latin: 'Bluefaced Leicester',  origin: 'Yorkshire Dales, UK', purpose: 'Outer shell · warmth & shape', percent: 68, photo: 'fabric_wool',  cert: 'RWS' },
    { name: 'Portuguese linen',  latin: 'Linum usitatissimum', origin: 'Minho, Portugal',     purpose: 'Outer shell · breathability', percent: 32, photo: 'fabric_linen', cert: 'OEKO-TEX' },
    { name: 'Mulberry silk',     latin: 'Bombyx mori',          origin: 'Como, Italy',         purpose: 'Lining · soft slide',         percent: 100, photo: 'fabric_silk', cert: 'GOTS' },
    { name: 'Corozo nut buttons', latin: 'Phytelephas',          origin: 'Ecuador',             purpose: 'Closure · vegetable ivory',    percent: 4,  photo: 'fabric_horn', cert: 'FSC' }
  ],

  sizes: [
    { size: 'XS', bust: 86,  waist: 70,  hip: 92,  length: 103, sleeve: 60 },
    { size: 'S',  bust: 90,  waist: 74,  hip: 96,  length: 104, sleeve: 61 },
    { size: 'M',  bust: 94,  waist: 78,  hip: 100, length: 105, sleeve: 62 },
    { size: 'L',  bust: 100, waist: 84,  hip: 106, length: 106, sleeve: 63 },
    { size: 'XL', bust: 106, waist: 90,  hip: 112, length: 107, sleeve: 64 },
    { size: 'XXL',bust: 112, waist: 96,  hip: 118, length: 108, sleeve: 65 }
  ],

  swatches: [
    { name: 'Almond',   hex: '#C9A87E', image: 'product_coat_almond',   stock: 'In stock', code: 'AL-01' },
    { name: 'Obsidian', hex: '#1F2026', image: 'product_coat_obsidian', stock: 'In stock', code: 'OB-02' },
    { name: 'Bone',     hex: '#E8DFCE', image: 'product_coat_bone',     stock: 'Low stock', code: 'BN-03' },
    { name: 'Moss',     hex: '#5E6B4A', image: 'product_coat_moss',     stock: 'In stock', code: 'MS-04' },
    { name: 'Clay',     hex: '#B26B4C', image: 'product_coat_clay',     stock: 'Made to order', code: 'CL-05' }
  ],

  related: [
    { name: 'Linen overshirt',  price: 165, image: 'product_linen_shirt',  color: '#E8DFCE', sizes: 'XS – XL', tag: 'Bestseller' },
    { name: 'Wool trouser',     price: 220, image: 'product_wool_trouser', color: '#3C3D44', sizes: 'XS – XXL', tag: null },
    { name: 'Leather tote',     price: 295, image: 'product_leather_tote', color: '#9C7959', sizes: 'One size', tag: null },
    { name: 'Knit cardigan',    price: 185, image: 'product_cardigan',     color: '#C9A87E', sizes: 'XS – XL', tag: 'New' },
    { name: 'Silk scarf',       price:  95, image: 'product_scarf',        color: '#B26B4C', sizes: 'One size', tag: null }
  ],

  details: {
    intro: 'The Almond Coat is our answer to the throwaway overcoat. Cut from a wool–linen weave milled in the Yorkshire Dales, finished with a charmeuse silk lining and four corozo-nut buttons. Designed to live in your closet for a decade.',
    story: 'We met our wool mill in 2019, on a cold spring morning in Hawes. They have spun their own yarn since 1907, and the wool they use is from a closed flock of Bluefaced Leicester sheep grazed within fifteen miles of the mill. Every metre of cloth carries that origin.',
    care:  'Hang on a wide wooden hanger between wears. Air outside once a season. Spot-clean small marks with a damp soft cloth; for anything more, take it to a wool specialist. With basic care, this coat is built to outlast the trend cycle several times over.',
    notes: [
      'Designed in Lisbon · made in Porto',
      'Cut from a single bolt of cloth',
      'Hand-finished hems and buttonholes',
      'Sustainable supply chain · fully traceable'
    ]
  },

  video: {
    eyebrow: 'A short film',
    title: 'Inside the atelier',
    duration: '2:14',
    description: 'Spend three minutes inside our Porto atelier with the team who cut and sew every garment by hand.'
  },

  imageText: {
    eyebrow: 'Our practice',
    title_pre: 'Slowly,',
    title_em: 'by hand.',
    body: 'Every garment we make passes through six pairs of hands. From the first cut of cloth in the morning, to the final fold in the box at night, no step is automated. This is what makes the difference you can feel.',
    cta: 'Read the full story →'
  }
};
